import api from '@/api/_imagerieRapports'
import { VueEditor } from 'vue2-editor'

function key() {
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20)
}
export default {
    name: 'ImagerieRapport', components: { VueEditor },
    props: { examenId: { type: Number, required: true }, dossier: { type: Boolean, default: false }, typeExamenId: Number, context: { type: Object, default: () => ({}) } },
    data() { return { report: null, title: '', content: '', reason: '', models: [], modelError: '', selected: '',
        loading: true, busy: false, error: '', notice: '', generation: 0, pending: null, replaceConfirm: false,
        confirmed: false, correction: false, validationKey: null,
        toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']] } },
    computed: {
        dirty() { return !!this.report && (this.title !== this.report.title || this.content !== this.report.content || this.reason !== (this.report.correction_reason || '')) },
        writable() { return this.report && this.report.can_write && (this.report.status !== 'validated' || this.correction) }
    },
    watch: {
        examenId: { immediate: true, handler() { this.load() } },
        dirty(value) { this.confirmed = false; this.validationKey = null; this.$emit('dirty', value) },
        busy(value) { this.$emit('busy', value) }
    },
    mounted() {
        this.onUnload = event => { if (this.dirty || this.busy) { event.preventDefault(); event.returnValue = '' } }
        window.addEventListener('beforeunload', this.onUnload)
        if (this.$router) this.removeRouteGuard = this.$router.beforeEach((to, from, next) => next(this.canLeave()))
    },
    beforeDestroy() { this.generation++; window.removeEventListener('beforeunload', this.onUnload); if (this.removeRouteGuard) this.removeRouteGuard() },
    methods: {
        canLeave() { return !this.busy && (!this.dirty || window.confirm('Le compte rendu contient des modifications non enregistrées. Fermer sans les enregistrer ?')) },
        insertModel(confirmed = false) {
            if (this.busy || this.selected === '') return
            const model = this.models[Number(this.selected)]
            if (!model || !model.model_field) return
            if (this.content.replace(/<[^>]*>/g, '').trim() && !confirmed) { this.replaceConfirm = true; return }
            const c = this.context
            const values = { NOM_PATIENT: c.patient || c.nom_patient, NOM_MEDECIN: c.prescripteur || c.nom_prescripteur,
                DATE_NAISSANCE_PATIENT: c.date_naissance, AGE_PATIENT: c.age, VILLE: c.ville, DATE: c.date_demande_examen || c.date, NOM_CLINIQUE: c.nom_clinique }
            const escape = value => String(value == null ? '' : value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]))
            this.content = String(model.model_field.default_value || '').replace(/\[([A-Z_]+)\]/g, (match, name) => name in values ? escape(values[name]) : match)
            this.title = model.model_field.champ || this.title || 'Compte rendu'
            this.replaceConfirm = false; this.notice = 'Modèle inséré dans ce compte rendu uniquement. Relisez et complétez le texte.'
        },
        accept(data) { this.report = data; this.title = data.title || ''; this.content = data.content || ''; this.reason = data.correction_reason || ''; this.pending = null; this.confirmed = false; this.correction = false; this.validationKey = null; this.$emit('state', data) },
        async validate() {
            if (this.busy || !this.writable || this.dirty || !this.confirmed || this.report.status !== 'draft') return
            this.validationKey = this.validationKey || key(); this.busy = true; this.error = ''; const generation = this.generation
            try {
                const data = await api.validate(this.examenId, { version: this.report.version, confirmed: true, request_key: this.validationKey })
                if (generation !== this.generation) return
                this.accept(data); this.notice = 'Compte rendu validé.'; this.$emit('changed')
            } catch (e) {
                if (generation === this.generation) this.error = e.response && e.response.status === 409 ? 'Le brouillon a changé. Rechargez et relisez-le avant de valider.' : 'Validation impossible. Vous pouvez réessayer.'
            } finally { if (generation === this.generation) this.busy = false }
        },
        async load() {
            const generation = ++this.generation
            this.loading = true; this.error = ''; this.notice = ''; this.report = null; this.pending = null
            this.models = []; this.modelError = ''; this.selected = ''
            if (!this.dossier) api.models(this.typeExamenId).then(data => { if (generation === this.generation) this.models = Array.isArray(data) ? data : [] })
                .catch(() => { if (generation === this.generation) this.modelError = 'Les modèles sont indisponibles. Vous pouvez rédiger librement.' })
            try { const data = await api.get(this.examenId, this.dossier); if (generation === this.generation) this.accept(data) }
            catch (_) { if (generation === this.generation) this.error = 'Impossible de charger le compte rendu. Réessayez.' }
            finally { if (generation === this.generation) this.loading = false }
        },
        async save() {
            if (this.busy || !this.writable) return
            this.error = ''; this.notice = ''
            if (!this.title.trim() || !this.content.replace(/<[^>]*>/g, '').trim()) { this.error = 'Renseignez le titre et le compte rendu.'; return }
            const payload = { version: this.report.version, title: this.title, content: this.content, correction_reason: this.reason || null }
            const signature = JSON.stringify(payload)
            if (!this.pending || this.pending.signature !== signature) this.pending = { signature, key: key() }
            this.busy = true; const generation = this.generation
            try {
                const data = await api.save(this.examenId, { ...payload, request_key: this.pending.key })
                if (generation !== this.generation) return
                this.accept(data); this.notice = 'Brouillon enregistré. Il n’est pas encore validé.'; this.$emit('changed')
            } catch (e) {
                if (generation === this.generation) this.error = e.response && e.response.status === 409
                    ? 'Le compte rendu a changé. Votre texte est conservé ; copiez-le avant de recharger.'
                    : 'Enregistrement impossible. Votre texte est conservé ; vous pouvez réessayer.'
            } finally { if (generation === this.generation) this.busy = false }
        }
    }
}
